<template>
  <section>
    <figure class="w-100 d-flex justify-content-center mb-5">
      <img src="/img/site/modal-success-payment.png" alt="" />
    </figure>
    <div class="d-flex flex-column justify-content-center content-center mt-1">
      <h3 class="mb-3">
        {{ $t('manageplan.component.modal.success-payment.title') }}
      </h3>
      <p class="px-5 mx-4 text-gray-500 mt-3">
        {{ $t('manageplan.component.modal.success-payment.description') }}
      </p>
      <CButton @click="setModal(null)" color="primary" class="px-5 py-2 mt-3">
        {{ $t('manageplan.component.modal.success-payment.link') }}
      </CButton>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModalLoadingPayment',

  methods: {
    setModal() {
      this.$store.dispatch('backOffice/steps/setModalComponent', { modalName: '', componentName: '' }).then(() => {
        this.$store
          .dispatch('auth/getUserSession', this.$route.params.organizationId)
          .finally(() => {
            this.$router.replace({ name: 'waitingConfiguration' })
          })
      })
    },
  },
}
</script>

<style lang="scss"></style>
